export { hcpForm as hcpFormValidationSchema } from './hcp-form.validation-schema';
